// extracted by mini-css-extract-plugin
export default {"Wrapper":"layout_Wrapper__+RS7Q","mainheader":"layout_mainheader__J5SnL"};